<template>
    <MonthPickerCellTrigger
        v-slot="{ monthValue }"
        :class="
            cn('ds-calendar-cell-trigger flex h-10 w-full items-center justify-center rounded-full p-0 font-normal', props.class)
        "
        v-bind="forwardedProps"
    >
        <button
            class="h-full w-full rounded-full p-0 font-normal focus:outline-none"
            type="button"
        >
            {{ monthValue }}
        </button>
    </MonthPickerCellTrigger>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils';
import { reactiveOmit } from '@vueuse/core';
import type { MonthPickerCellTriggerProps } from 'reka-ui';
import { MonthPickerCellTrigger, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<MonthPickerCellTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<style scoped lang="scss">
@use './styles/ds-calendar-cell-trigger';
</style>
